import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import AdsConfigV2 from './containers/AdsConfigV2/index.ts';
import Payouts from './containers/Payouts/index.ts';

const Publishers = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  AdsConfig: lazy(() => import('./containers/AdsConfig/index.tsx')),
  Overview: lazyNamed(() => import('./containers/Overview/index.tsx'), 'Overview'),
  Campaigns: lazyNamed(() => import('./containers/Campaigns/index.tsx'), 'Campaigns'),
  Payouts,
  SellersJson: lazyNamed(() => import('./containers/SellersJson/index.tsx'), 'SellersJson'),
  Exclusions: {
    ExcludedCampaigns: lazyNamed(() => import('./containers/Exclusions/containers/ExcludedCampaigns/index.tsx'), 'ExcludedCampaigns'),
    ExcludedCustomers: lazyNamed(() => import('./containers/Exclusions/containers/ExcludedCustomers/index.tsx'), 'ExcludedCustomers'),
    Layout: lazy(() => import('./containers/Exclusions/components/Layout.tsx')),
  },
  Traffic: {
    Layout: lazy(() => import('./containers/Traffic/components/Layout.tsx')),
    TrafficDashboard: lazyNamed(() => import('./containers/Traffic/containers/TrafficDashboard/index.tsx'), 'TrafficDashboard'),
    PlacementGroups: lazyNamed(() => import('./containers/Traffic/containers/PlacementGroups/index.tsx'), 'PlacementGroups'),
  },
  AdsConfigV2,
};

export default Publishers;
